import { Injectable } from '@angular/core';

interface StoredUsername {
  username: string;
  expiresAt: number;
}

@Injectable({
  providedIn: 'root',
})
export class UsernameStorageService {
  private readonly storageKey = 'snk.username';
  private readonly ttlMs = 24 * 60 * 60 * 1000;

  saveUsername(username: string): void {
    const payload: StoredUsername = {
      username,
      expiresAt: Date.now() + this.ttlMs,
    };
    localStorage.setItem(this.storageKey, JSON.stringify(payload));
  }

  getUsername(): string | null {
    const stored = this.readStored();
    if (!stored) {
      return null;
    }

    if (Date.now() > stored.expiresAt) {
      this.clearUsername();
      return null;
    }

    const refreshed: StoredUsername = {
      username: stored.username,
      expiresAt: Date.now() + this.ttlMs,
    };
    localStorage.setItem(this.storageKey, JSON.stringify(refreshed));

    return stored.username;
  }

  hasValidUsername(): boolean {
    return Boolean(this.getUsername());
  }

  clearUsername(): void {
    localStorage.removeItem(this.storageKey);
  }

  private readStored(): StoredUsername | null {
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw) as StoredUsername;
      if (!parsed.username || !parsed.expiresAt) {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }
}
